/**
 * Icon Size
 */
export var IconSize;
(function (IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["HUGE"] = "huge";
    IconSize["SMALLER"] = "smaller";
})(IconSize || (IconSize = {}));
/**
 * Icon Status
 */
export var IconStatus;
(function (IconStatus) {
    IconStatus["SUCCESS"] = "success";
    /** @deprecated use ERROR instead */
    IconStatus["DANGER"] = "danger";
    IconStatus["ERROR"] = "error";
    IconStatus["WARNING"] = "warning";
    /** @deprecated v4 => MAIN */
    IconStatus["TERTIARY"] = "tertiary";
    /** @deprecated v4 => ACCENT */
    IconStatus["PRIMARY"] = "primary";
    IconStatus["INFO"] = "info";
    IconStatus["WHITE"] = "white";
    IconStatus["GREY"] = "grey";
})(IconStatus || (IconStatus = {}));
/**
 * Icon Color
 */
export var IconColor;
(function (IconColor) {
    IconColor["SUCCESS"] = "SUCCESS";
    /** @deprecated use ERROR instead */
    IconColor["DANGER"] = "DANGER";
    IconColor["ERROR"] = "ERROR";
    IconColor["INFO"] = "INFO";
    IconColor["WARNING"] = "WARNING";
    /** @deprecated v4 => MAIN */
    IconColor["TERTIARY"] = "TERTIARY";
    IconColor["WHITE"] = "WHITE";
    /** @deprecated v4 => NEUTRAL */
    IconColor["GREY"] = "GREY";
    /** @deprecated v4 => ACCENT */
    IconColor["PRIMARY"] = "PRIMARY";
})(IconColor || (IconColor = {}));
/**
 * Text Icon Direction
 */
export var IconPosition;
(function (IconPosition) {
    IconPosition["UP"] = "up";
    IconPosition["DOWN"] = "down";
    IconPosition["LEFT"] = "left";
    IconPosition["RIGHT"] = "right";
})(IconPosition || (IconPosition = {}));
export var TextIconMarkup;
(function (TextIconMarkup) {
    TextIconMarkup["DIV"] = "div";
    TextIconMarkup["A"] = "a";
    TextIconMarkup["P"] = "p";
    TextIconMarkup["SPAN"] = "span";
})(TextIconMarkup || (TextIconMarkup = {}));
export var IconStatusPosition;
(function (IconStatusPosition) {
    IconStatusPosition["TOP"] = "top";
    IconStatusPosition["BOTTOM"] = "bottom";
})(IconStatusPosition || (IconStatusPosition = {}));
//# sourceMappingURL=IconEnum.js.map